export const salesTypes = {
  TOKEN: 'token',
  NFT: 'nft',
};

export const getSalesTypeFromPath = (pathname = '') => {
  const lowerPathname = pathname.toLowerCase();

  if (lowerPathname.startsWith('/sales/nft')) {
    return salesTypes.NFT;
  }

  if (lowerPathname.startsWith('/sales/token') || lowerPathname === '/sales') {
    return salesTypes.TOKEN;
  }

  return null;
};

export const isNftSalesPath = (pathname = '') => {
  return getSalesTypeFromPath(pathname) === salesTypes.NFT;
};

export const getSalesTitleFromPath = (pathname = '', fallbackTitle = 'Sales') => {
  const salesType = getSalesTypeFromPath(pathname);

  if (salesType === salesTypes.NFT) {
    return 'NFT Sales';
  }

  if (salesType === salesTypes.TOKEN) {
    return 'Token Sales';
  }

  return fallbackTitle;
};
